import React from 'react';
import PropTypes from 'prop-types';
import PrivacySideNav from './PrivacySideNav';
import styles from './styles/PrivacyFlowLayout.scss';
const PrivacyFlowLayout = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: styles.pageWithNav
}, /*#__PURE__*/React.createElement("div", {
  className: styles.container
}, /*#__PURE__*/React.createElement(PrivacySideNav, null), /*#__PURE__*/React.createElement("main", {
  className: styles.content
}, children)));
export default PrivacyFlowLayout;